import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import useUiState from 'packages/workspace/services/store/ui-store';
import type { FC } from 'react';

const BackdropLoader: FC = () => {
  const uiState = useUiState();

  return (
    <>
      <Backdrop open={uiState.isLoading} className="rhs-backdrop">
        <CircularProgress color="primary" aria-label="Backdrop Loader" />
      </Backdrop>
    </>
  );
};
export default BackdropLoader;
